/**
 * This module contains the UI
 * to build the output instruction category
 */

// TODO:
// - reduce unneeded notifications
// - unbind events of removed UI elements
// - unify styles
(function() {
  const $ = require('jQuery');
  const io_widgets = require('../instruction_widgets/io_widgets');
  const icons = require('../../icons');
  const widgets = require('../widgets');
  const utils = require('./utils');
  const helpers = require('../../helpers');
  const ml = require('../../machinelogic');

  const { autocompleteComponent } = require('../vse_ui/vse_components/base_components');

  function create(pParameters) {
    const lLibrary = pParameters.library;
    const lApp = pParameters.application;
    const lSequence = pParameters.sequence;
    const lInstruction = pParameters.instruction;
    const _lDiv = $('<div class="ml_instruction h_layout"/>');
    const _lCard = widgets.card(icons[lInstruction.getCategory()], function () {
      lSequence.removeInstruction(lSequence.getInstructionIndex(lInstruction));
    }).attr('id', widgets.idGenerator.nextInstructionId());
    const _lParameterMap = {};
    let _lFilteredActionsSet;
    // Note (alevy): this function does not return a widget
    // it adds widgets to _lCard
    const _parameterWidget = function (pParameterInfo, pParameter) {
      let _lWidget;
      const lIsSelectedOutputPowerSwitchModule = function() {
        const lUuid = lInstruction.getParameter('outputUuid');
        const lOutput = lLibrary.getConfigManager().getOutputByUuid(lUuid);

        if (lOutput) {
          return lOutput.getDeviceType() === 'powerSwitchModule';
        } else {
          return false;
        }
      };

      switch (pParameterInfo.format) {
        // Note(alevy): build digital output instruction
        case 'oneOf': {
          if (pParameterInfo.unit == 'ioExpander' && pParameterInfo.name == 'outputUuid') {
            _lWidget = io_widgets.outputParamWidget(
              lLibrary.getConfigManager(),
              'Output Name',
              pParameterInfo.description,
              pParameterInfo.default == ml.reservedUuids.NONE,
              lInstruction.getParameter(pParameter),
              function (pValue) {
                lInstruction.setParameter(pParameter, pValue);
              });
          }
          else if (pParameterInfo.name == 'value') {
            _lWidget = widgets.listWidget(pParameterInfo.name, lIsSelectedOutputPowerSwitchModule() ? [{value: 1, text: "On"}, {value: 0, text: "Off"}] : [1, 0], pParameterInfo.description, lInstruction.getParameter(pParameter), function (pValue) {
              lInstruction.setParameter(pParameter, Number(pValue));
            });
          } else {
            _lWidget = widgets.listWidget(pParameterInfo.name, pParameterInfo.values, pParameterInfo.description, lInstruction.getParameter(pParameter), function (pValue) {
              lInstruction.setParameter(pParameter, pValue);
            });
          }
          break;
        }
        // Note(alevy): This is to build
        // the generate event instruction
        case 'string': {
          if (pParameter == 'topic') {
            _lWidget = widgets.stringWidget(pParameterInfo.name, pParameterInfo.description, lInstruction.getParameter(pParameter), function (pValue) {
              lInstruction.setParameter(pParameter, pValue);
            }, [helpers.required]);
            // The "evaluatable" parameter comes from the mm-execution-engine where it acts as a flag to use the expression widget
            // To be removed in the future once we are comfortable with deleting the old widget behaviour
          } else if (pParameterInfo.acceptedVariableTypes.includes('evaluatable')) {
            _lWidget = autocompleteComponent(
              helpers.transformToTitleCase(pParameterInfo.name),
              pParameterInfo.description,
              lInstruction.getParameter(pParameter),
              lApp.listAllApplicationParameterNames(),
              (pValue) => { lInstruction.setParameter(pParameter, pValue); },
              [helpers.getExpressionValidationFunction(lApp.getParametersObject())],
            ).widget;
          } else {
            _lWidget = widgets.stringWidget(pParameterInfo.name, pParameterInfo.description, lInstruction.getParameter(pParameter), function (pValue) {
              _lWidget.children('input').attr('title', pValue);
              lInstruction.setParameter(pParameter, pValue);
            }, null, { allowEmpty: true });
          }
          break;
        }
        default: {
          _lWidget = widgets.baseWidget(pParameterInfo.name).append($('<div>' + pParameterInfo.format + ' not supported</div>'));
          break;
        }
      }

      if (_lWidget) {
        _lWidget.addClass('v_layout spaced');
        _lParameterMap[pParameter] = _lWidget;
        _lCard.parameters.append(_lWidget);
      }
    };
    const _lActionSet = lLibrary.getInstructionSet()[lInstruction.getCategory()];
    let _lActions;
    const _onAction = function (pAction) {
      if (['digitalOutput'].includes(pAction)) {
        if (lLibrary.getConfigManager().listOutputs().length == 0) {
          widgets.messageBox('Please configure an output before using it. Your changes have been reverted.', 'warning');
          _lActions.setValue(lInstruction.getName());
          return;
        }
      }
      lInstruction.setName(pAction);
    };
    const buildInstruction = utils.buildInstruction(_parameterWidget);

    _lCard.icon.find('h5').addClass('ml_number');
    _lCard.icon.removeClass('ml_icon').addClass('ml_icon_instruction_widget');

    if (_lActionSet) {
      // Please see VentionCo/mm-vention-control#569
      _lFilteredActionsSet = utils.getActions(lLibrary, lInstruction);
      _lActions = widgets.listWidget(lInstruction.getCategory(), utils.getActionList(_lFilteredActionsSet), 'Action to be performed', lInstruction.getName(), _onAction);
      buildInstruction(_lCard, lInstruction, _lActions, _lFilteredActionsSet);
      _lCard.append($('<div class="ml_animated_background"/>'));
      _lDiv.append(_lCard);

      const lInstructionListeners = utils.getInstructionListener({
        actions: _lActions,
        buildInstruction: buildInstruction,
        card: _lCard,
        filteredActionsSet: _lFilteredActionsSet,
        instruction: lInstruction,
        library: lLibrary,
        parameterMap: _lParameterMap,
      });

      // Instruction and Application listeners
      lInstruction.addListener(lInstructionListeners);

      _lDiv.on('remove', function onRemoveTriggerInstruction() {
        lInstruction.removeListener(lInstructionListeners);
      });
    }


    return _lDiv;
  }

  /* Module export glue */
  /* global define */
  const gExports = {
    create: create,
  };

  const gModule = typeof module;
  if (gModule !== 'undefined' && module.exports != undefined) {
    module.exports = gExports;
  } else if (define != undefined && typeof define === 'function' && define.amd) {
    define([], function () { return gExports; });
  }
}());
